import React from "react";
import { CarouselContainer } from "./CarouselContainer";
import { LoadMoreContainer } from "./LoadMoreContainer";
import { ListItem } from "~/models/list";
import { CardListItem, getCards } from "~/common/api/page";
import { CardPostItem, getPostsWithTags } from "~/common/api/post";
import { Logger } from "~/utils/logger";
const logger = new Logger("card-container", "info");

export const CardContainerView = (props: {
  firstCardFullWidth: string;
  numberOfCards: { size: number };
  showSearchBar: string;
  cardType?: string;
  cards?: { list: ListItem }[];
  postTags?: string[];
  postCategory?: string;
}) => {
  const [cardItems, setCardItems] = React.useState<
    CardListItem[] | CardPostItem[]
  >([]);
  const [loaded, setLoaded] = React.useState(false);

  // console.log("CardContainerView props cards:", props.cards);

  // load the card details for each card in our cards array
  // we need to do this to get the title, description, link, and image for each card to display in the frontend
  // and to be able to search through the cards if the search bar is enabled
  React.useEffect(() => {
    const loadCards = async () => {
      if (props.cardType === "posts") {
        const cardListItems = await getPostsWithTags(
          props.postCategory,
          props.postTags,
        );
        logger.debug("details:", cardListItems);
        setCardItems(cardListItems);
        setLoaded(true);
      } else {
        // while we're loading the cards, put a placeholder card in the state so that
        // the frontend doesn't shift its layout after we load the card details
        setCardItems(
          props.cards?.map((card, index) => ({
            id: index,
            title: card.list?.listTitle ?? "Loading...",
            description: card.list?.listDescription ?? "Loading...",
            link: "#",
            image: { url: "" },
            focalPoint: { x: 0.5, y: 0.5 },
            searchTags: [],
          })) || [],
        );

        const cardListItems = await getCards(props.cards);
        logger.debug("details:", cardListItems);
        setCardItems(cardListItems);
        setLoaded(true);
      }
    };

    loadCards();
  }, [
    props.cards,
    props.numberOfCards,
    props.cardType,
    props.postTags,
    props.postCategory,
  ]);

  logger.debug("Rendering CardContainerView with props: ", props);
  if (!props.numberOfCards) {
    logger.warn("numberOfCards prop is missing, defaulting to 5");
  }

  return (
    <>
      {/* small sizes get carousel, hidden on larger screens */}
      <div className="tw:!block tw:md:!hidden">
        <CarouselContainer items={cardItems} />
      </div>

      {/* large sizes get grid, hidden on small screens */}
      <div className="tw:!hidden tw:md:!block">
        <LoadMoreContainer
          firstCardFullWidth={props.firstCardFullWidth === "yes"}
          pageSize={props.numberOfCards ? props.numberOfCards.size : 5}
          searchBar={props.showSearchBar === "yes"}
          items={cardItems}
          loaded={loaded}
        />
      </div>
    </>
  );
};
